import { ENVIRONMENTS } from '@/assets/src/constants';

const API_URL = process.env.VUE_APP_API_URL;
const IS_LOCAL = process.env.NODE_ENV !== ENVIRONMENTS.production && process.env.NODE_ENV !== ENVIRONMENTS.development;
const IS_PROD = process.env.NODE_ENV === ENVIRONMENTS.production;
const COGNITO_USER_URL = `https://${process.env.VUE_APP_AMPLIFY_REGION}.console.aws.amazon.com/cognito/users/?region=${process.env.VUE_APP_AMPLIFY_REGION}#/pool/${process.env.VUE_APP_AMPLIFY_USER_POOL_ID}/users/`;

export { API_URL, IS_LOCAL, IS_PROD, COGNITO_USER_URL };
